import React, {Component} from 'react';
import {SortableTableHeader} from "../../components/table/sortable-table-header";

export default class SiteTableContactHeader extends Component
{
  static Layout = [
    { column: "name", width: 2, },
    { column: "role", width: 3, },
    { column: "telephoneNumber", name: "Telephone Number" },
    { column: "email", name: "E-Mail" }
  ];

  render() {
    return (<SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={SiteTableContactHeader.Layout}/>)
  }
}